/**
 * Pull-to-Refresh Indicator Component
 *
 * Visual feedback for pull-to-refresh gesture
 */

import { Loader2, ArrowDown } from "lucide-react";

interface PullToRefreshIndicatorProps {
  pullDistance: number;
  isRefreshing: boolean;
  shouldTriggerRefresh: boolean;
}

export default function PullToRefreshIndicator({
  pullDistance,
  isRefreshing,
  shouldTriggerRefresh,
}: PullToRefreshIndicatorProps) {
  if (pullDistance === 0 && !isRefreshing) return null;

  const rotation = Math.min((pullDistance / 80) * 180, 180);
  const opacity = Math.min(pullDistance / 80, 1);

  return (
    <div
      className="fixed top-0 left-0 right-0 z-30 flex justify-center pointer-events-none"
      style={{
        transform: `translateY(${Math.min(pullDistance, 80)}px)`,
        transition: pullDistance === 0 ? 'transform 0.3s ease-out' : 'none',
      }}
    >
      <div
        className="bg-white rounded-full shadow-lg p-3 flex items-center justify-center"
        style={{ opacity }}
      >
        {isRefreshing ? (
          <Loader2 className="w-6 h-6 text-blue-500 animate-spin" />
        ) : (
          <ArrowDown
            className={`w-6 h-6 transition-colors ${
              shouldTriggerRefresh ? 'text-blue-500' : 'text-gray-400'
            }`}
            style={{
              transform: `rotate(${rotation}deg)`,
              transition: 'transform 0.1s ease-out',
            }}
          />
        )}
      </div>
    </div>
  );
}
